//#region types
import { ChartDataSet } from "models/propTypes/chartProps";
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
import { Moment } from "moment";
//#endregion
//#region components
import Chart from "chart.js";
import moment from "moment";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ChartHelper = {
  getLabelsSet: (datasets?: ChartDataSet[]): string[] => {
    if (datasets === undefined) return [];

    let labels: string[] = [];
    datasets.forEach((dataset) => {
      labels = [...labels, (dataset.label as string) ?? ""];
    });

    return labels;
  },

  getLabel: (label?: string | string[]): string => {
    if (label === undefined) return "";
    else if (typeof label === "string") return label;
    else {
      const labelToDisplay: string = "";
      label.forEach((l) => {
        labelToDisplay.concat(l);
      });

      return labelToDisplay;
    }
  },

  legendClickCallback: (chartCanvasId: string, target: HTMLLIElement): void => {
    const parent = target.closest("ul");
    const legendLi = target.closest("li");

    if (parent == null || legendLi == null) return;

    Chart.helpers.each(Chart.instances, function (instance: any) {
      if (instance.chart.canvas.id === chartCanvasId && parent !== null) {
        const chart = instance.chart;
        const index = Array.prototype.slice.call(parent.children).indexOf(legendLi);

        let hide: boolean = false;

        if (chart?.data?.datasets === undefined || chart.data.datasets[index] === undefined) {
          return;
        }

        const metaOfTarget = chart.getDatasetMeta(index);

        if (metaOfTarget.hidden === undefined || metaOfTarget.hidden === null || metaOfTarget.hidden === false) {
          hide = true;
          legendLi?.classList.add(cssExports.hiddenLegend);
        } else {
          hide = false;
          legendLi?.classList.remove(cssExports.hiddenLegend);
        }

        chart.data.datasets.forEach((element: any, i: number) => {
          const meta = chart.getDatasetMeta(i);

          if (i === index) {
            if (hide) {
              meta.hidden = true;
            } else {
              meta.hidden = false;
            }
          }
        });

        chart.update();
      }
    });
  },

  generateLegend: (chart: Chart, colorProperty: "border" | "background"): string => {
    const text = [];
    text.push(`<div class="${cssExports.legend}"><ul class="${cssExports.legendUL}">`);

    const dataSet = chart?.data?.datasets;

    if (dataSet !== null && dataSet !== undefined) {
      for (let i = 0; i < (dataSet.length ? dataSet.length : 0); i++) {
        const data = dataSet[i];
        const label = data?.label ?? "";
        const pointerBackgroundColor =
          (colorProperty === "border" ? data?.borderColor : data?.backgroundColor) ??
          GraphConstants.DefaultPointerColor;

        text.push(ChartHelper.generateLegendItem(pointerBackgroundColor as string, label));
      }
    }

    text.push("</ul></div>");
    return text.join("");
  },

  generateLegendItem: (
    pointerBackgroundColor: string,
    label: string | number | number[] | string[] | Date | Date[] | moment.Moment | moment.Moment[]
  ): string => {
    return `<li class="${cssExports.legendLi}"><div class="${
      cssExports.legendIndicator
    }"><span style="background-color:${pointerBackgroundColor}"></span></div><div class="${
      cssExports.legendText
    }">${label.toString()}</div></li>`;
  },

  getDoughnutChartColorPalette: (
    colorPaletteType: ChartEnums.DoughnutChartColorPalette,
    dataPoints?: ChartDataSet[]
  ): string[] => {
    switch (colorPaletteType) {
      case ChartEnums.DoughnutChartColorPalette.DEFAULT:
        return GraphConstants.ChartsDefaultColorPalette.slice(0, dataPoints !== undefined ? dataPoints.length : 0);
      case ChartEnums.DoughnutChartColorPalette.STATUS:
        return GraphConstants.DoughnutChartStatusColorPalette;
      case ChartEnums.DoughnutChartColorPalette.INVOICE_STATUS:
        return GraphConstants.DoughnutChartInvoiceStatusColorPalette;
      case ChartEnums.DoughnutChartColorPalette.INCOMING_INVOICE_STATUS:
        return GraphConstants.DoughnutChartIncomingInvoiceStatusColorPalette;
      case ChartEnums.DoughnutChartColorPalette.RATING:
        return GraphConstants.DoughnutChartRatingColorPalette;
      case ChartEnums.DoughnutChartColorPalette.EMPTY:
        return GraphConstants.DoughnutChartEmptyColorPalette;
    }
  },

  validateFormatChartYAxis: (value: number | string, values: number[] | string[]): string => {
    const isMln = (val: number) => val > 1000000;
    const result = (values as number[]).some(isMln);
    return result === true
      ? (value = +value / 1000000 + " " + GraphConstants.DefaultDataUnitMillion)
      : +value < 1000
        ? value + " " + GraphConstants.DefaultDataUnit
        : (value = +value / 1000 + " " + GraphConstants.DefaultDataUnitThousend);
  },

  getDisplayLabel: (label: string | number) => {
    const displayLabel = typeof label === "string" ? label.split(";")[0] : label;
    return displayLabel;
  },

  is2DArray: (obj: any) => {
    if (!Array.isArray(obj)) {
      return false;
    }

    for (const element of obj) {
      if (!Array.isArray(element)) {
        return false;
      }
    }

    return true;
  },

  getLableForArray: (
    label: (string | number | Moment | Date)[],
    xAxisLabelFormatter?: (label?: string) => string
  ): string[] => {
    if (label.length === 0) return [];
    return label.map((item) =>
      typeof item === "string"
        ? xAxisLabelFormatter !== undefined
          ? xAxisLabelFormatter(item)
          : item
        : item.toString()
    );
  },

  getLableFor2DArray: (
    label: (string[] | number[] | Moment[] | Date[])[],
    xAxisLabelFormatter?: (label?: string) => string
  ): string[] => {
    if (label.length === 0) return [];
    return ChartHelper.getLableForArray(label[0], xAxisLabelFormatter);
  },
};

export default ChartHelper;
